// Fachliche Konfiguration des Vereins.
//
// Die Werte kommen zur Laufzeit aus /api/config/public und damit aus der
// Tabelle tblconfig — pflegbar über Admin → App-Konfiguration, ohne neuen Build.
// Die REACT_APP_*-Variablen dienen nur noch als Rückfall, falls der Server
// (noch) keine Werte liefert.
//
// AppContext ruft applyServerConfig() auf, bevor die App etwas rendert
// (App.jsx zeigt bis dahin eine Ladeanzeige). Die Komponenten sehen deshalb
// immer die Serverwerte und nicht die Rückfallwerte.

const cfg = {
  orgName:           process.env.REACT_APP_ORG_NAME              || 'Meine Organisation',
  orgFullName:       process.env.REACT_APP_ORG_FULL_NAME         || 'Meine Organisation e.V.',
  orgAbbr:           process.env.REACT_APP_ORG_ABBR              || 'ORG',
  orgWebsite:        process.env.REACT_APP_ORG_WEBSITE           || '#',
  orgStreet:         process.env.REACT_APP_ORG_STREET            || '',
  orgPostal:         process.env.REACT_APP_ORG_POSTAL            || '',
  orgCity:           process.env.REACT_APP_ORG_CITY              || '',
  orgEmail:          process.env.REACT_APP_ORG_EMAIL             || '',
  orgPhone:          process.env.REACT_APP_ORG_PHONE             || '',
  orgRegister:       process.env.REACT_APP_ORG_REGISTER          || '',
  orgCourt:          process.env.REACT_APP_ORG_COURT             || '',
  orgDpoName:        process.env.REACT_APP_ORG_DPO_NAME          || '',
  adminRoleName:     process.env.REACT_APP_ADMIN_ROLE_NAME       || 'Admin',
  costumeTerm:       process.env.REACT_APP_COSTUME_TERM          || 'Kostüm',
  costumeTermPlural: process.env.REACT_APP_COSTUME_TERM_PLURAL   || 'Kostüme',
  eventTerm:         process.env.REACT_APP_EVENT_TERM            || 'Event',
  eventTermPlural:   process.env.REACT_APP_EVENT_TERM_PLURAL     || 'Events',
  memberTerm:        process.env.REACT_APP_MEMBER_TERM           || 'Mitglied',
  memberTermPlural:  process.env.REACT_APP_MEMBER_TERM_PLURAL    || 'Mitglieder',
  costumeTypes:      (process.env.REACT_APP_COSTUME_TYPES || '').split(',').filter(Boolean),
  vendorEmail:       process.env.REACT_APP_VENDOR_EMAIL           || '',
};

// Schlüssel aus /api/config/public → Feld in cfg
const SERVER_KEY_TO_FIELD = {
  Org_Name:           'orgName',
  Org_FullName:       'orgFullName',
  Org_Abbr:           'orgAbbr',
  Org_Website:        'orgWebsite',
  Org_Street:         'orgStreet',
  Org_Postal:         'orgPostal',
  Org_City:           'orgCity',
  Org_Email:          'orgEmail',
  Org_Phone:          'orgPhone',
  Org_Register:       'orgRegister',
  Org_Court:          'orgCourt',
  Org_DpoName:        'orgDpoName',
  Term_AdminRole:     'adminRoleName',
  Term_Costume:       'costumeTerm',
  Term_CostumePlural: 'costumeTermPlural',
  Term_Event:         'eventTerm',
  Term_EventPlural:   'eventTermPlural',
  Term_Member:        'memberTerm',
  Term_MemberPlural:  'memberTermPlural',
  Vendor_Email:       'vendorEmail',
};

// Übernimmt die Serverwerte. Das Objekt wird mutiert, nicht ersetzt —
// die importierenden Komponenten halten eine Referenz darauf.
export function applyServerConfig(data) {
  if (!data) return cfg;
  for (const [key, field] of Object.entries(SERVER_KEY_TO_FIELD)) {
    const value = data[key];
    // Leere Werte nicht übernehmen, sonst überschreiben sie die Rückfallwerte
    if (value !== undefined && value !== null && value !== '') cfg[field] = value;
  }
  return cfg;
}

export default cfg;
